/**
 * _calc_decking.js — browser mirror of application/utils/calculators/decking.py.
 *
 * Change this, decking.py and tests/fixtures/calculator_cases.json together.
 */

import { ceilWhole, noAnswer, plainNumber, roundHalfUp } from "./_calc_math.js";

const SCREWS_PER_CROSSING = 2;

export function calculate(v) {
    const lengthMm = v.length * 1000;
    const widthMm = v.width * 1000;
    const pitch = v.board_width + v.gap;
    if (lengthMm <= 0 || widthMm <= 0 || pitch <= 0 || v.board_length <= 0 || v.spacing <= 0) {
        return noAnswer(["area", "rows", "metres", "boards", "joists", "screws"]);
    }
    const waste = 1 + v.wastage / 100;
    const rows = ceilWhole((widthMm + v.gap) / pitch);
    const metres = roundHalfUp(rows * v.length * waste, 1);
    const boards = ceilWhole(metres / v.board_length);
    const joists = Math.floor(roundHalfUp(lengthMm / v.spacing, 6)) + 1;
    const screws = ceilWhole(rows * joists * SCREWS_PER_CROSSING * waste);
    return {
        outputs: { area: roundHalfUp(v.length * v.width, 2), rows, metres, boards, joists, screws },
        items: [
            { description: `Decking boards, ${plainNumber(v.board_width)} mm, `
                           + `${plainNumber(v.board_length)} m lengths`, quantity: boards },
            { description: `Joists, ${plainNumber(v.width)} m`, quantity: joists },
            { description: "Decking screws", quantity: screws },
        ],
        warnings: [],
    };
}
